import { cn } from '@/frontend/lib/utils'

import type { FieldLayoutProps } from './form-layout-context'

/**
 * Compact layout: Label and control inline, minimal spacing
 * Description as tooltip/title, error inline
 */
export function CompactLayout({ label, description, control, error, className }: FieldLayoutProps) {
  return (
    <div
      className={cn('flex min-w-0 items-center gap-2 [&>*]:w-auto', className)}
      title={typeof description === 'string' ? description : undefined}
    >
      {label}
      {control}
      {error}
    </div>
  )
}
